import React, { useState, useRef, useEffect, useContext } from 'react';
import { get, post, put } from '../utils/api';
import { useParams, useNavigate } from 'react-router-dom';
import ReactPlayer from 'react-player';
import SingleQuestionPage from './Quiz/SingleQuestionPage/SingleQuestionPage';
import { MaybeZoom } from './Quiz/QuestionZoom/QuestionZoom';
import { useInClassroom } from '../contexts/InClassroomContext';
import { useHideAskAddy, useNavVisibility } from '../contexts/NavVisibilityContext';
import { AuthContext } from '../contexts/AuthContext';
import { logout } from '../services/authService';
import { useAuth } from '../contexts/AuthContext';
import { Button } from '@/components/shadcn/button';
import posthog from 'posthog-js';
import { useSparks } from '../contexts/SparksContext';
import SparksAddyBurst from './Sparks/SparksAddyBurst';
import AddyAvatar from './Sparks/AddyAvatar';
import useCosmeticCatalogue from './Sparks/useCosmeticCatalogue';
import useBeginLessonTally from './Sparks/useBeginLessonTally';
import SparksStarsUpdate from './Sparks/SparksStarsUpdate';
import { useIsPhone } from '../hooks/useMediaQuery';
import { exitVideoFullscreen } from '../utils/videoFullscreen';
//import newBaseSway from '../media/transparent-base-sway.webm';

import correctSound from '../media/correct-answer-sound.mp3';
import correctAudio from '../media/correct-audio.mp3';
import incorrectAudio from '../media/incorrect-audio.mp3';

import { Card, CardHeader, CardTitle, CardDescription } from '@/components/shadcn/card';
import LessonThermometer from './LessonThermometer/LessonThermometer';
import './HomePageV2.css';
import './LessonViewFocusLayout.css';
import ErrorBoundary from './ErrorBoundary';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import the styles

function HomePageV2({ onQuizStart, preventNavigation, onStateChange, onInputChange, isTutorPreview = false, previewState = null, resolvedTrack = null }) {
  // const { lessonId } = useParams(); dont need this
  const [latestLesson, setLatestLesson] = useState(null);
  const [showAnimation, setShowAnimation] = useState(false);
  const [loading, setLoading] = useState(!isTutorPreview);
  const [error, setError] = useState(null);
  const [sessionStarted, setSessionStarted] = useState(!!(isTutorPreview && previewState));
  const [isTalking, setIsTalking] = useState(false);
  const [currentLessonStep, setCurrentLessonStep] = useState(null);
  const [basiclessonText, setBasicLessonText] = useState('');
  // null means no video is playing. Previously false, which caused `false === 0` on step 0
  // to always evaluate as false, preventing the first video from ever playing.
  const [whichVideo, setWhichVideo] = useState(null);
  const [isAudioPlaying, setIsAudioPlaying] = useState(false);
  const [selectAnswerMessage, setSelectAnswerMessage] = useState(true);
  const [answerSelected, setAnswerSelected] = useState(false);
  const [explanationText, setExplanationText] = useState('');
  const [showButtons, setShowButtons] = useState(true);
  const [isInitialStep, setIsInitialStep] = useState(true);
  const [showCelebration, setShowCelebration] = useState(false);

  const [addyisQuestioning, setAddyisQuestioning] = useState(false);

  const audioElementRef = useRef(null);
  const isPhone = useIsPhone();
  const lessonPlayerRef = useRef(null);
  const audioContextRef = useRef(null);
  const audioQueue = useRef([]);
  const isPlayingAudio = useRef(false);
  const [needsUserInteraction, setNeedsUserInteraction] = useState(false);
  const [hasUserInteracted, setHasUserInteracted] = useState(false);

  const { setIsAuthenticated } = useContext(AuthContext);
  const { user, logout, loggedInChild } = useAuth();
  const sparks = useSparks();
  const cosmeticCatalogue = useCosmeticCatalogue(!isTutorPreview ? loggedInChild?._id : null);
  useBeginLessonTally(loggedInChild?._id, sessionStarted && !isTutorPreview); // for the end-of-lesson recap
  const addyContainerRef = useRef(null); // Sparks bubbles spawn from Addy
  // True only when this lesson is rendered inside a live classroom call.
  const inClassroom = useInClassroom();
  const navigate = useNavigate();

  const [childTopic, setChildTopic] = useState(null);
  const [isLessonComplete, setIsLessonComplete] = useState(false);
  const [showCharacter, setShowCharacter] = useState(false);
  useHideAskAddy(showCharacter);

  const [isCurrentStepQuestion, setIsCurrentStepQuestion] = useState(false);
  const [currentQuizQuestion, setCurrentQuizQuestion] = useState(null);

  // True only while an actual lesson QUESTION step is on screen (not the tutor
  // preview). Used to hide the top nav, the step progress bar, the "select an
  // answer" prompt and Addy's Response, and to grow the question card — on
  // question steps only, in EVERY context (classroom, home learning, Core
  // Skills...). Regular lesson steps keep them; Addy stays visible.
  const { setNavHidden } = useNavVisibility();
  const stepForQuestion = latestLesson && latestLesson.steps[currentLessonStep];
  const questionActive =
    !isTutorPreview && isCurrentStepQuestion &&
    (!answerSelected || !(stepForQuestion && stepForQuestion.AnswerExplanation));
  useEffect(() => {
    setNavHidden(questionActive);
    return () => setNavHidden(false);
  }, [questionActive, setNavHidden]);

  // Outside a live call the nav is hidden and there is no Leave-call, so offer an
  // Exit (confirm first; lesson progress is saved per step).
  const handleExit = () => {
    confirmAlert({
      title: 'Exit?',
      message: 'Your progress is saved.',
      buttons: [
        { label: 'Exit', onClick: () => navigate('/children-dashboard') },
        { label: 'Stay', onClick: () => {} },
      ],
    });
  };

  // Add this function near the top of your component
  const getDisplayType = (type) => {
    if (['Question','Multiple-Choice-Question', 'Free-Text-Question', 'Blank-Box-Question', 'Drag-And-Drop-Question', 'Mixed'].includes(type)) {
      return 'Question';
    }
    return type;
  };

  // When tutor preview: hydrate from synced student state; no fetch
  useEffect(() => {
    if (isTutorPreview && previewState?.latestLesson != null) {
      setLatestLesson(previewState.latestLesson);
      setCurrentLessonStep(typeof previewState.currentStep === 'number' ? previewState.currentStep : 0);
      setSessionStarted(true);
      setLoading(false);
      setShowCharacter(true);
    }
  }, [isTutorPreview, previewState?.latestLesson, previewState?.currentStep]);

  useEffect(() => {
    if (isTutorPreview) return;
    fetchLessonAndChildTopic();
  }, [/*lessonId*/]); // dont need lessonId


    // Add effect to notify parent of state changes
    // remove the params and dependencies that i don't need at some point
    useEffect(() => {
      if (isTutorPreview || !onStateChange) return;
      onStateChange({
        latestLesson,
        currentLessonStep,
        totalSteps: latestLesson?.steps?.length,
        isQuizMode: false,
        lessonTitle: latestLesson?.title,
        currentView: 'lesson',
        sessionStarted,
        basiclessonText,
        isLessonComplete
      });
    // basiclessonText is intentionally omitted from deps: it is set in the same
    // handlers that update currentLessonStep, so it will always be fresh when
    // currentLessonStep triggers this effect. Including it caused the effect to
    // fire on every step's audio narration, broadcasting a new learning-state-update
    // on every character change and causing unnecessary tutor re-renders.
    }, [
      currentLessonStep,
      latestLesson,
      sessionStarted,
      isLessonComplete,
      onStateChange,
      isTutorPreview
    ]);
  

  const fetchLessonAndChildTopic = async () => {
    try {
      setLoading(true);
      if (!loggedInChild) throw new Error("No logged in child found");

      const childData = await get(`/children/${loggedInChild._id}`, true);
      const topicId =
        resolvedTrack === 'classroom'   ? childData.classroomCurrentTopicId :
        resolvedTrack === 'remediation' ? childData.remediationCurrentTopicId :
        /* home / default */              childData.homeCurrentTopicId;
      if (topicId) {
        const trackQuery = resolvedTrack ? `?track=${resolvedTrack}` : '';
        const childTopic = await get(`/childTopics/${loggedInChild._id}/${topicId}${trackQuery}`, true);
        setChildTopic(childTopic);
        const step = childTopic.currentLessonStep ?? 0;
        setCurrentLessonStep(step);
        if (childTopic.currentLesson) {
          setLatestLesson(childTopic.currentLesson);
        } else {
          throw new Error("No current lesson found for this child topic");
        }
      } else {
        throw new Error("No current topic found for this child");
      }

      setLoading(false);
    } catch (err) {
      console.error('Error fetching lesson and child topic:', err);
      setError(`Failed to fetch the lesson: ${err.message}`);
      setLoading(false);
    }
  };




  
  const updateAudioAndAnimation = (step, stepIndex) => {
    //console.log('Updating audio and animation for step:', stepIndex);
    setWhichVideo(stepIndex);
    setIsCurrentStepQuestion(getDisplayType(step.Type) === 'Question');
    
    if (getDisplayType(step.Type) !== 'Question') {
      // For non-question steps, set answerSelected to true to allow animation to play
      setAnswerSelected(true);
      setAddyisQuestioning(false);
    } else {
      // Reset for question steps
      setAnswerSelected(false);
      setAddyisQuestioning(true);
    }

  }; 

  //--------------------------------------------------------------------------------
  //This useEffect sets the currentQuizQuestion in the case that the current step is a question
  //and also plays the audio for the current step
  //--------------------------------------------------------------------------------
  useEffect(() => {
    if (sessionStarted && latestLesson && latestLesson.steps[currentLessonStep]) {
      const currentStep = latestLesson.steps[currentLessonStep];
      //remember : currentLessonStep is just a number that is the index 
      // of the current step in the lesson
      //currentStep is the step object for the current step in the lesson

      updateAudioAndAnimation(currentStep, currentLessonStep);
      
      // Update the current quiz question if it's a question step
      if (getDisplayType(currentStep.Type) === 'Question') {
        setCurrentQuizQuestion(currentStep.quizQuestionId);
      } else {
        setCurrentQuizQuestion(null);
      }

      // Skip audio in tutor preview (read-only mirror)
      if (!isTutorPreview && !isInitialStep) {
      setTimeout(() => {
        playAudio(currentStep.audio);
      }, 100); 
    }

    }
  }, [currentLessonStep, sessionStarted, latestLesson, isTutorPreview, isInitialStep]);

  const playAudio = (audioSource) => {
    if (audioElementRef.current) {
      initializeAudioContext();
      if (audioSource) {
        audioElementRef.current.src = audioSource;
        audioElementRef.current.load();
      }
      const playPromise = audioElementRef.current.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            //console.log('Audio started playing');
            setIsTalking(true);
            setShowButtons(false); // Hide buttons while audio is playing
          })
          .catch(e => {
            console.error("Error playing audio:", e);
            setNeedsUserInteraction(true);
          });
      }

      // Add an 'ended' event listener to show buttons when audio finishes
      audioElementRef.current.onended = () => {
        //console.log('Audio playback ended');
        setIsTalking(false);
        setShowButtons(true); // Show buttons after audio finishes
      };
    }
  };

  const handleStartLearning = async () => {
    if (latestLesson) {
      try {
        const startStep = currentLessonStep ?? 0;
        setBasicLessonText(latestLesson.steps[startStep].TalkingPoint);
        setCurrentLessonStep(startStep);
        setSessionStarted(true);
        setShowCharacter(true);

        if (!isTutorPreview) {
          posthog.capture('lesson_started', {
            lessonId: latestLesson?._id ?? null,
            topicId: childTopic?.topicId ?? null,
            startStep,
            totalSteps: latestLesson?.steps?.length ?? null,
            track: resolvedTrack ?? null,
          });
        }

        // Play the audio for the first step
        if (latestLesson.steps[startStep].audio) {
          playAudio(latestLesson.steps[startStep].audio);
          setHasUserInteracted(true);
        }

        setIsInitialStep(false);
        setAnswerSelected(false);
        setAddyisQuestioning(false);
        setSelectAnswerMessage(true);
        setShowButtons(true);
        setExplanationText('');
        setShowAnimation(true);
      } catch (err) {
        console.error('Error starting lesson:', err);
      }
    }
  };

  const handleContinueLearning = async () => {
    const nextStep = currentLessonStep + 1;
    if (latestLesson && nextStep < latestLesson.steps.length) {
      setBasicLessonText(latestLesson.steps[nextStep].TalkingPoint);
      setCurrentLessonStep(nextStep);
      if (!isTutorPreview) {
        posthog.capture('lesson_step_advanced', {
          lessonId: latestLesson?._id ?? null,
          fromStep: currentLessonStep,
          toStep: nextStep,
          totalSteps: latestLesson.steps.length,
          leftQuestionStep: getDisplayType(latestLesson.steps[currentLessonStep]?.Type) === 'Question',
          track: resolvedTrack ?? null,
        });
      }
      setAnswerSelected(false);
      setAddyisQuestioning(false);
      setSelectAnswerMessage(true);
      setExplanationText('');
      setShowButtons(true);
      
      // Update the current lesson step in the database
      if (loggedInChild && childTopic) {
        try {
          await put(`/childTopics/${loggedInChild._id}/${childTopic.topicId}/lessonStep`, { currentLessonStep: nextStep, track: resolvedTrack }, true);
        } catch (error) {
          console.error('Failed to update lesson step in database:', error);
        }
      }

      // The audio will be played by the useEffect hook
    } else {
      setIsLessonComplete(true);

      if (!isTutorPreview) {
        posthog.capture('lesson_completed', {
          lessonId: latestLesson?._id ?? null,
          topicId: childTopic?.topicId ?? null,
          totalSteps: latestLesson?.steps?.length ?? null,
          track: resolvedTrack ?? null,
        });
      }

      // Lesson steps count as a daily streak activity for classroom and remediation tracks.
      // Home track requires quiz completion instead (handled server-side in quiz.service.ts).
      if (!isTutorPreview && resolvedTrack !== 'home' && loggedInChild) {
        try {
          const result = await post(`/children/${loggedInChild._id}/streak-activity`, {}, true);
          sparks.pushStreakResult(result);
        } catch (e) {
          // Non-fatal — lesson completion is unaffected if streak update fails
        }
      }
    }
  };

  const handleGoBack = async () => {
    const previousStep = currentLessonStep - 1;
    if (previousStep >= 0) {
      setBasicLessonText(latestLesson.steps[previousStep].TalkingPoint);
      setCurrentLessonStep(previousStep);
      if (!isTutorPreview) {
        posthog.capture('lesson_step_back', {
          lessonId: latestLesson?._id ?? null,
          fromStep: currentLessonStep,
          toStep: previousStep,
          track: resolvedTrack ?? null,
        });
      }
      setAnswerSelected(false);
      setAddyisQuestioning(false);
      setSelectAnswerMessage(true);
      setExplanationText('');
      setShowButtons(true);
      
      // Update the current lesson step in the database
      if (loggedInChild && childTopic) {
        try {
          await put(`/childTopics/${loggedInChild._id}/${childTopic.topicId}/lessonStep`, { currentLessonStep: previousStep, track: resolvedTrack }, true);
        } catch (error) {
          console.error('Failed to update lesson step in database:', error);
        }
      }
    } else {
      //console.log("Already at the first step of the lesson");
    }
    setIsLessonComplete(false);
  };


  const handleAnswerSelect = (isCorrect, selectedAnswer) => {
    //console.log('Answer selected:', { isCorrect, selectedAnswer });

    setAddyisQuestioning(false);
    
    
    if (latestLesson && latestLesson.steps[currentLessonStep]) {
      const step = latestLesson.steps[currentLessonStep];
      if (!isTutorPreview) {
        posthog.capture('lesson_question_answered', {
          lessonId: latestLesson?._id ?? null,
          stepIndex: currentLessonStep,
          questionId: step?._id ?? null,
          questionType: step?.Type ?? null,
          isCorrect,
          track: resolvedTrack ?? null,
        });
      }
      // Sparks (once per step per day; Home Learning has its own allowance): recorded server-side, drawn from Addy on reply.
      if (!isTutorPreview && loggedInChild?._id && latestLesson?._id) {
        const stepTrack = ['classroom', 'home', 'remediation'].includes(resolvedTrack) ? { track: resolvedTrack } : {};
        put(`/childTopics/${loggedInChild._id}/step-answer`, { lessonId: latestLesson._id, stepIndex: currentLessonStep, correct: !!isCorrect, ...stepTrack }, true)
          .then((res) => sparks.pushFromResponse(res))
          .catch(() => {}); // non-fatal: the lesson never waits on Sparks
      }
      setSelectAnswerMessage(false);
      setShowButtons(false);
      
      const playFeedbackAudio = () => {
        // Play correct or incorrect audio
        setShowCelebration(false);
        const audioToPlay = isCorrect ? correctAudio : incorrectAudio;
        playAudio(audioToPlay);
        
        if (audioElementRef.current) {
          audioElementRef.current.onended = () => {
            setCurrentQuizQuestion(null);
            setAnswerSelected(true);          
            setShowButtons(true);
            if (step.AnswerExplanation) {
              setExplanationText(step.AnswerExplanation);
              
              // Handle the delay between animation and explanation audio start
              if (step.animationDelay >= 0) {
                playAudio(step.AnswerExplanationAudio);
                setTimeout(() => {
                  setWhichVideo(currentLessonStep);
                }, step.animationDelay * 1000);
              } else {
                setWhichVideo(currentLessonStep);
                setTimeout(() => {
                  playAudio(step.AnswerExplanationAudio);
                }, Math.abs(step.animationDelay) * 1000);
              }
            } else {
              // If there's no explanation, don't show animation or play audio
              setWhichVideo(null);
              setExplanationText('');
            }
          };
        }
      };
      
      if (isCorrect) {
        // First play correctSound if the answer is correct
        playAudio(correctSound);
        setShowCelebration(true);
        
        // Set up the onended event for correctSound to play the feedback audio
        if (audioElementRef.current) {
          audioElementRef.current.onended = playFeedbackAudio;
        }
      } else {
        // If the answer is incorrect, directly play the feedback audio
        playFeedbackAudio();
      }
    }
  };

  const initializeAudioContext = () => {
    if (!audioContextRef.current) {
      audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
    }
    if (audioContextRef.current.state === 'suspended') {
      audioContextRef.current.resume();
    }
  };


  // need this function to make audio autoplay work on ios
  // ios requires user interaction before autoplaying
  const handlePlayAudio = () => {
    if (audioElementRef.current) {
      audioElementRef.current.play()
        .then(() => setNeedsUserInteraction(false))
        .catch(error => console.error('Error playing audio:', error));
    }
    setHasUserInteracted(true);
  };
  



  const handleStartQuiz = async () => {
    if (!latestLesson || !loggedInChild) {
      console.error('Missing required data to start quiz');
      return;
    }

    if (!isTutorPreview) {
      posthog.capture('lesson_quiz_started', {
        lessonId: latestLesson?._id ?? null,
        topicId: childTopic?.topicId ?? null,
        track: resolvedTrack ?? null,
      });
    }

    if (preventNavigation) {
      onQuizStart(latestLesson, childTopic, user, loggedInChild);
    }
    else {

    try {
      // Set learning stage to "quiz"
      const stageResponse = await put(`/childTopics/${loggedInChild._id}/${childTopic.topicId}/learningStage`, { learningStage: 'quiz', track: resolvedTrack }, true);
      sparks.pushFromResponse(stageResponse); // "Lesson done! +100" (Sparks §2.2)

      // Create quiz submission with 20 random questions
      const response = await post('/quiz/quiz-submissions', {
        lessonId: latestLesson._id,
        userId: user._id,
        childId: loggedInChild._id,
        topicId: childTopic.topicId,
        QuizStatus: 'Pending',
        isCoreSkill: false,
        track: resolvedTrack,
        isForcedRed: false,
      }, true);

      const quizSubmissionId = response._id;

      // Navigate to the quiz page
      navigate(`/quiz/${childTopic.topicId}/${latestLesson._id}`, { state: { quizSubmissionId } });
    } catch (error) {
      console.error('Error starting quiz:', error);
      // Handle error (e.g., show error message to user)
    }
  }

  };


  if (loading && !isTutorPreview) {
    return <div className="flex items-center justify-center min-h-screen">Loading...</div>;
  }

  if (error && !isTutorPreview) {
    return <div className="flex items-center justify-center min-h-screen text-red-500">{error}</div>;
  }

  const currentStep = latestLesson && latestLesson.steps[currentLessonStep];


  return (
    <ErrorBoundary>
    <div className="min-h-screen p-4 bg-slate-200">
      {/* Hidden audio element */}
      <audio ref={audioElementRef} style={{ display: 'none' }} />

      <div className="w-full max-w-none" style={{ opacity: 1.0 }}>
        {!sessionStarted ? (
          // Initial view with centered content
          <div className="flex flex-col items-center justify-center min-h-screen">
            <h1 className="text-3xl font-semibold text-foreground mb-8 text-center px-4">Welcome to Your Lesson!</h1>
            <Button
              onClick={handleStartLearning}
              disabled={isTutorPreview}
              className="bg-indigo-600 hover:bg-indigo-700 text-white py-3 px-6 text-xl transition duration-300 ease-in-out transform hover:scale-105 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              {currentLessonStep === 0 ? "Start Learning!" : "Continue Learning"}
            </Button>
            {!preventNavigation && !isTutorPreview ? (
              <Button
                onClick={() => navigate('/dashboard')}
                variant="outline"
                className="mt-3"
              >
                Open Dashboard
              </Button>
            ) : null}
          </div>
        ) : (
          // Lesson content view
          <div className="flex flex-col">
          
            {isLessonComplete ? (
              <div className="flex flex-col items-center justify-center px-4">
                <p className="text-xl sm:text-2xl font-bold mb-4 text-center">
                  You've finished the lesson! Are you ready to do some practice questions?
                </p>
                {!isTutorPreview && <SparksStarsUpdate />}
                <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-4">
                  <Button
                    onClick={handleStartQuiz}
                    disabled={isTutorPreview}
                    className="bg-indigo-600 hover:bg-indigo-700 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                  >
                    Start Practice Questions
                  </Button>
                  <Button
                    onClick={handleGoBack}
                    disabled={isTutorPreview}
                    className="bg-gray-500 hover:bg-gray-600 text-white font-bold py-2 px-4 rounded focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400"
                  >
                    Go Back
                  </Button>
                </div>
              </div>
            ) : (
              // Existing lesson content (shared layout classes for alignment with tutor focus mode)
              <div className={`lesson-view-focus flex flex-col${questionActive ? ' lesson-view-focus--question' : ' lesson-view-focus--teaching'}`}>
                {/* Left-edge thermometer: lesson progress on every step (incl. questions). */}
                {!isTutorPreview && latestLesson && currentLessonStep != null && (
                  <LessonThermometer current={currentLessonStep + 1} total={latestLesson.steps.length} />
                )}
                {/* Container for SingleQuestionPage, ReactPlayer, and ProgressBar */}
                <div className="lesson-view-focus__video">
                  {latestLesson && currentLessonStep >= 0 && (
                    <div className="lesson-view-focus__video-inner">
                      {latestLesson.steps[currentLessonStep].animation && (
                        <ReactPlayer
                          url={latestLesson.steps[currentLessonStep].animation}
                          playing={whichVideo === currentLessonStep && (!isCurrentStepQuestion || answerSelected)}
                          playbackRate={1 / (latestLesson.steps[currentLessonStep].slowDownMultiplier || 1)}
                          muted={true}
                          controls={true}
                          config={{
                            file: {
                              attributes: {
                                controlsList: "nofullscreen nodownload noplaybackrate",
                              },
                            },
                          }}
                          width="100%"
                          height="100%"
                          ref={lessonPlayerRef}
                          playsinline={true}
                          onError={(e) => console.error('Error playing video:', e)}
                          onReady={() => console.log('Video is ready to play')}
                          onStart={() => console.log('Video started playing')}
                          onPause={() => console.log('Video paused')}
                          onEnded={() => {
                            console.log('Video ended');
                            // Phones: if the child chose fullscreen, drop back to the lesson so Continue is visible.
                            if (isPhone) exitVideoFullscreen(lessonPlayerRef.current?.getInternalPlayer());
                          }}
                        />
                      )}
                    </div>
                  )}
                  {isCurrentStepQuestion && (!answerSelected || !currentStep.AnswerExplanation) && (
                    <div className="absolute inset-0 flex items-center justify-center">
                      <div className="bg-white rounded-lg shadow-lg p-4 w-full h-full overflow-y-auto flex items-center justify-center max-md:items-start max-md:p-2">
                        {currentQuizQuestion && (
                          <MaybeZoom enabled={!isTutorPreview} immersive fillHeight onExit={inClassroom ? undefined : handleExit}>
                            <SingleQuestionPage
                              key={`question-${currentLessonStep}`}
                              quizQuestion={currentQuizQuestion}
                              onAnswerSelect={handleAnswerSelect}
                              ButtonsAreClickable={!isTutorPreview && !answerSelected}
                              onInputChange={onInputChange}
                            />
                          </MaybeZoom>
                        )}
                      </div>
                    </div>
                  )}
                </div>

                {/* Step progress now shown by the left-edge LessonThermometer. */}
                <div className="w-full sm:w-[90%] md:w-[80%] lg:w-[70%] mx-auto mt-4 relative">
                  <div className="flex flex-col items-center justify-center">
                    {/* Character container */}
                    {!isTutorPreview && isCurrentStepQuestion && <SparksAddyBurst addyRef={addyContainerRef} showCounter={questionActive} />}
                    {showCharacter && (
                      <div ref={addyContainerRef} className="character-container absolute right-0 bottom-0">
                        {/* Celebrates a correct answer with the child's chosen clip; otherwise talks while audio plays, asks on question steps. */}
                        <div className="character-container__addy">
                          <AddyAvatar
                            equipped={sparks.equipped}
                            catalogue={cosmeticCatalogue}
                            size="100%"
                            bleed
                            mood={!isTalking ? 'sway' : isCurrentStepQuestion && addyisQuestioning ? 'asking' : 'talking'}
                            celebrating={showCelebration}
                          />
                        </div>
                      </div>
                    )}
                  </div>
                </div>
                {/* User Interaction Buttons */}
                <div className="mt-2 flex flex-wrap justify-center items-center gap-2">
                  {isCurrentStepQuestion && selectAnswerMessage ? (
                    /* Removed on question steps in every context (immersive view). */
                    null
                  ) : (
                    <>
                      {currentLessonStep > 0 && showButtons && (
                        <Button
                          onClick={handleGoBack}
                          disabled={isTutorPreview}
                          className="bg-gray-500 text-white px-3 py-1 sm:px-4 sm:py-2 text-sm sm:text-base mr-2"
                        >
                          Go Back
                        </Button>
                      )}
                      {showButtons && (
                        <Button
                          onClick={handleContinueLearning}
                          disabled={isTutorPreview}
                          className="bg-blue-500 text-white px-3 py-1 sm:px-4 sm:py-2 text-sm sm:text-base"
                        >
                          Continue learning
                        </Button>
                      )}
                    </>
                  )}
                </div>

                {/* Lesson Text Display — hidden during classroom question steps
                    (declutter); the answer explanation still shows afterwards. */}
                {!questionActive && (basiclessonText || explanationText) && (
                  <div className="lesson-view-focus__talking-point">
                    <h3 className="lesson-view-focus__talking-point-heading">Addy's Response:</h3>
                    <p className="lesson-view-focus__talking-point-text">
                      {explanationText || basiclessonText}
                    </p>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
      </div>

      {/* Add this near your other UI elements */}
      {needsUserInteraction && !hasUserInteracted && !isTutorPreview && (
        <Button onClick={handlePlayAudio} className="bg-blue-500 text-white px-4 py-2 rounded">
          Play Audio
        </Button>
      )}
      </div>
    </ErrorBoundary>
  );
}

export default HomePageV2;
